import { MobileNavigation } from "./header/MobileNavigation";
import { SearchBar } from "./header/SearchBar";
import { ActionButtons } from "./header/ActionButtons";
import { GlobalCreateMenu } from "./header/GlobalCreateMenu";
import { UnitIndicator } from "./header/UnitIndicator";
import { Breadcrumbs } from "./Breadcrumbs";

export function DashboardHeader() {
  return (
    <>
      <header className="bg-background/85 border-b border-border backdrop-blur-md sticky top-0 z-40">
        <div className="px-3 md:px-6 py-2 flex items-center gap-3 md:gap-4">
          <div className="flex items-center gap-2 shrink-0">
            <MobileNavigation />
            <a href="/" className="hidden md:inline-flex items-center hover:opacity-80 transition-opacity">
              <img src="/lovable-uploads/roadhaven-logo.svg" alt="RoadHaven Dealer Hub" className="h-14 w-auto" />
            </a>
          </div>
          <div className="flex-1 max-w-xl">
            <SearchBar />
          </div>
          <div className="shrink-0 flex items-center gap-2">
            <GlobalCreateMenu />
            <ActionButtons />
          </div>
        </div>
      </header>
      <UnitIndicator />
      <Breadcrumbs />
    </>
  );
}
